import { namespace } from '../../../../../FrontendBundle/Resources/js/ofcs';

/**
 * @param {string} orientation
 * @param {string} hit
 * @param {number} position
 * @param {number} distance
 * @constructor
 */
export default class Guide {
    constructor(orientation, hit, position, distance) {
        this.orientation = orientation;
        this.hit = hit;
        this.position = position;
        this.distance = distance;
    }

    /**
     * @return {string}
     */
    getOrientation() {
        return this.orientation;
    }

    /**
     * @return {string}
     */
    getHit() {
        return this.hit;
    }

    /**
     * @return {number}
     */
    getPosition() {
        return this.position;
    }

    /**
     * @return {number}
     */
    getDistance() {
        return this.distance;
    }
}

namespace('Ofcs.Editor.Canvas');
window.Ofcs.Editor.Canvas.Guide = Guide;
